import { create } from 'zustand';
import api from '../lib/api';

const useSettingsStore = create((set, get) => ({
  settings: null,
  content: null,
  loading: true,
  error: null,

  fetchSettings: async () => {
    try {
      const [settingsRes, contentRes] = await Promise.all([
        api.get('/settings'),
        api.get('/content'),
      ]);
      const settings = settingsRes.data;
      const content = contentRes.data;

      // Apply title
      document.title = settings.site_title || 'Авто Маркет';

      // Apply design system CSS vars
      if (settings.design_system) {
        const ds = settings.design_system;
        const root = document.documentElement;
        if (ds.primary_bg) root.style.setProperty('--navy', ds.primary_bg);
        if (ds.surface) root.style.setProperty('--surface', ds.surface);
        if (ds.accent) root.style.setProperty('--accent', ds.accent);
        if (ds.accent_hover) root.style.setProperty('--accent-hover', ds.accent_hover);
        if (ds.text_primary) root.style.setProperty('--text-primary', ds.text_primary);
        if (ds.text_secondary) root.style.setProperty('--text-secondary', ds.text_secondary);
        if (ds.overlay_opacity) root.style.setProperty('--overlay', `rgba(10,25,47,${ds.overlay_opacity})`);
      }

      // Apply background
      if (settings.bg_image_url) {
        document.body.style.backgroundImage = `url(${settings.bg_image_url})`;
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center';
        document.body.style.backgroundAttachment = window.innerWidth > 768 ? 'fixed' : 'scroll';
      }

      set({ settings, content, loading: false });
    } catch (err) {
      console.error('Failed to fetch settings:', err);
      set({ loading: false, error: err.message });
    }
  },

  updateSettings: (newSettings) => set({ settings: newSettings }),
  updateContent: (newContent) => set({ content: newContent }),

  // Auth state
  isAuthenticated: !!localStorage.getItem('access_token'),
  login: (tokens) => {
    localStorage.setItem('access_token', tokens.access_token);
    localStorage.setItem('refresh_token', tokens.refresh_token);
    set({ isAuthenticated: true });
  },
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    set({ isAuthenticated: false });
  },

  // Compare state
  compareIds: [],
  toggleCompare: (id) => {
    const current = get().compareIds;
    if (current.includes(id)) {
      set({ compareIds: current.filter(i => i !== id) });
    } else if (current.length < 3) {
      set({ compareIds: [...current, id] });
    }
  },
  clearCompare: () => set({ compareIds: [] }),
}));

export default useSettingsStore;
